import { cn } from '@/_lib/utils'
import { SECTION_THEME_ENUM } from '@/_types/base'

import { getOrderThemeClasses } from '../../../../_utils/order-flow-section-theme-classes'

/**
 * Shared card shell for order product rows (templates, price-list items, banners).
 *
 * @param props - Layout props.
 * @param props.children - Main content (typically two columns when `split` is true on md+).
 * @param props.split - When true, lays out children in a column on small screens and a row on `md+`.
 * @param props.sectionTheme - Top-level category tint from step 1 (`ADULT` / `CHILD`); defaults to a white card.
 * @param props.className - Optional extra classes merged with the default card styles.
 */
export const ZOrderProductCard = ({
	children,
	split = false,
	sectionTheme = null,
	className
}: {
	children: React.ReactNode
	split?: boolean
	sectionTheme?: SECTION_THEME_ENUM | null
	className?: string
}) => {
	return (
		<div
			className={cn(
				split &&
					'flex flex-col md:flex-row md:justify-between md:items-end gap-6 md:gap-12',
				'rounded-2xl text-medante-purple-dark',
				getOrderThemeClasses(sectionTheme ?? null).card,
				'px-4 md:px-6 py-4 md:py-5 mb-2',
				className
			)}
		>
			{children}
		</div>
	)
}
